import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Código", value: true },
    { title: "Nombre", value: true },
    { title: "Email", value: true },
    { title: "Tipo usuario", value: true },
    { title: "", value: false },
    { title: "", value: false },
    { title: "", value: false },
];

class AdministratorUsersView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            total: 0,
            sucursales: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            jefeArea: [],

            userConfig: null
        }
    }

    componentDidMount = async () => {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liAdminUsers");

        const listsucursales = await apiClient.getSucursales();
        const listJefesArea = await apiClient.getlistJefesArea();
        await this.setState({
            sucursales: listsucursales.data,
            jefeArea: listJefesArea.data || [],
        })
    }

    SearchUsers = async filter => {
        await this.callDocumentsListService(filter);
    };

    callDocumentsListService = async (filter = { priceValue: '---', groupCodeValue: '---', employeeValue: '---' }) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);

        const adminUsersResponse = await apiClient.getAdminUsersList(filter);
        enableSpinner(false);
        if (adminUsersResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: adminUsersResponse.data.users,
                total: adminUsersResponse.data.totalRows
            });
        }
    };

    UpdateConfigUserFields = async config_ModulesInfo => {
        await this.setState({
            userConfig: config_ModulesInfo
        })
    }

    render() {
        const { headers, data, total, sucursales, userConfig, _user, jefeArea } = this.state;

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'ADMINISTRACIÓN DE USUARIOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="liAdminUsers" className="text-muted">
                            &nbsp;ADMINISTRACIÓN DE USUARIOS
                        </a>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"administratorUsers"}
                        data={data}
                        search={this.SearchUsers}
                        totalRows={total}
                        sucursales={sucursales}
                        jefeArea={jefeArea}
                        userConfig={userConfig}
                        UpdateConfigUserFields={this.UpdateConfigUserFields}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdministratorUsersView);
